import useApiController from "@hooks/useApiController"

export default function useSalonController(): Jury.Controllers.Salon {
    const { index, show } = useApiController("/api/jury/salons")
    return { index, show }
}